import React from "react";
import './ButtonBar.scss' ;
import TooltipIcon from "@ui/Tooltip/TooltipIconPasspoint";

import {useNavigate} from 'react-router-dom';

const ButtonBar = ({buttonDefs}) =>
{
    const navigate = useNavigate();
    const defaultBackButton = () =>
    {
        if (window.history.state && window.history.state.idx > 0)
        {
            navigate(-1);
        }
        else
        {
            navigate('/', {replace: true}); // the current entry in the history stack will be replaced with the new one with { replace: true }
        }
    }

    const renderButtons = () =>
    {
        return buttonDefs.map((def,index) =>
        {
            if (def.navOption === 'back')
            {
                return <TooltipIcon key={index} text={def.label} component={def.icon} color={def.color} onClick={defaultBackButton}/>
            }
            else
            {
                if ( def.onClick !== undefined)
                {
                    return <TooltipIcon key={index} text={def.label} component={def.icon} color={def.color} onClick={def.onClick}/>
                }
                else if ( def.href !== undefined )
                {
                    return <TooltipIcon key={index} text={def.label} component={def.icon} color={def.color} href={def.href} target={def.target}/>
                }
            }
        })
    }

    return (
        <div className="bar">
            <ul>
                {renderButtons()}
            </ul>
        </div>
    )
}

export default ButtonBar;